export default __webpack_public_path__ + "static/media/logo.523cb02f.svg";